<template>
    <el-popover
        ref="sms-create"
        placement="top"
        title=""
        width="760"
        trigger="manual"
        v-model="showSmsForm"
        :visible-arrow="false"
        popper-class="event-sms-create"
        v-on-clickaway="hideSmsForm"
        @hide="hideSmsForm"
    >
        <el-row class="mb10">
            <el-col :span="2" class="form-label">
                Кому
            </el-col>
            <el-col :span="3">
                <el-radio v-model="receiverType" label="contact" class="form-radio">
                    Клиенту
                </el-radio>
            </el-col>
            <el-col :span="3">
                <el-radio v-model="receiverType" label="employer" class="form-radio">
                    Сотруднику
                </el-radio>
            </el-col>
            <el-col :span="16">
                <el-select
                    v-model="receiverId"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    clearable
                    autocomplete
                    size="mini"
                >
                    <el-option v-for="item in receiverList" :key="item.id" :label="`${item.name} (${item.phone})`" :value="item.id" />
                </el-select>
                <div class="form-error" v-if="errors.receiverId" v-text="errors.receiverId[0]"></div>
                <div class="form-error" v-if="errors.receiverType" v-text="errors.receiverType[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb16">
            <el-col>
                <el-input
                    type="textarea"
                    :rows="5"
                    placeholder=""
                    v-model="text"
                />
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-button type="warning" @click="createSms">
                    Отправить
                </el-button>
                <el-button type="info" @click="hideSmsForm">
                    Отменить
                </el-button>
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/events.scss';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: 'EventSmsCreate',
    mixins: [
        clickaway
    ],
    data() {
        return {
            showSmsForm: false,
            receiverType: null,
            receiverId: null,
            text: null,
            canSendSms: false
        };
    },
    props: {
        entityType: {
            type: String,
            default: 'deal'
        },
        entityId: {
            type: Number,
            default: 0
        },
        entity: {
            type: Object,
            default: () => {}
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        receiverList() {
            if (this.receiverType === 'employer') {
                return this.$store.state.references.employers;
            }
            if (this.receiverType === 'contact') {
                return this.entity.contact_id ? [
                    {
                        id: this.entity.contact_id,
                        name: this.entity.contact.name,
                        phone: this.entity.contact.main_phone_number
                    }
                ] : [];
            }
            return [];
        },
        errors() {
            return this.$store.state.events.errors;
        }
    },
    methods: {
        hideSmsForm(event) {
            if (this.showSmsForm && event.target.className !== 'messages-menu-action') {
                this.showSmsForm = false;
                this.resetForm();
            }
        },
        resetForm() {
            this.$store.commit('events/clearErrors');
            this.canSendSms = true;
            this.receiverType = null;
            this.receiverId = null;
            this.text = null;
        },
        showSmsFormVisible() {
            this.showSmsForm = true;
            this.$emit('changeVisibility', true);
        },
        createSms() {
            if (!this.canSendSms) {
                let message = 'Нельзя отправить СМС. ';
                if (this.receiverType === null || this.receiverId === null) {
                    message += 'Не выбран получатель. ';
                }
                if (this.text === null || this.text.length === 0) {
                    message += 'Пустой текст сообщения. ';
                }
                if (this.receiverType === 'employer') {
                    const employer = this.receiverList.find(item => item.id === this.receiverId);
                    if (!employer || employer.phone.length === 0) {
                        message += 'У сотрудника нет номера телефона. ';
                    }
                }
                this.$message({
                    showClose: true,
                    message: message,
                    type: 'error',
                    duration: 5000,
                    customClass: this.alertClass()
                });
                return;
            }
            const params = {
                data: {
                    receiverId: this.receiverId,
                    receiverType: this.receiverType,
                    text: this.text
                },
                entityType: this.entityType,
                entityId: this.entityId
            };
            this.$store.dispatch('events/createSms', params).then((response) => {
                this.$notify({
                    duration: 5000,
                    title: 'Успешно',
                    dangerouslyUseHTMLString: true,
                    message: response,
                    type: 'success'
                });
                this.showSmsForm = false;
                this.resetForm();
                this.$emit('changeVisibility', false);
            }).catch(() => { });
        }
    },
    watch: {
        isVisible(value) {
            this.showSmsForm = value;
        },
        receiverType(value, prevValue) {
            if (value === 'contact') {
                let message = '';
                if (this.entity.contact_id === null) {
                    message = 'Нет связанного Клиента (контакта)';
                }
                if (this.entity.contact_id && this.entity.contact.main_phone_number === '') {
                    message = 'Для отправки СМС Клиенту необходимо указать в карточке Клиента телефон';
                }
                if (message.length) {
                    this.$message({
                        showClose: true,
                        message: message,
                        type: 'error',
                        duration: 5000,
                        customClass: this.alertClass()
                    });
                    this.canSendSms = false;
                    this.receiverType = prevValue;
                } else {
                    this.receiverId = this.entity.contact_id;
                    this.canSendSms = this.text && this.text.length;
                }
            } else {
                this.canSendSms = false;
                this.receiverId = null;
            }
        },
        receiverId(value) {
            this.canSendSms = value && this.receiverType && this.text && this.text.length;
        },
        text(value) {
            this.canSendSms = value && value.length;
        },
        showSmsForm(value) {
            if (value === false) {
                this.$emit('changeVisibility', false);
            }
        }
    }
};
</script>
